'use strict';

module Patersons {

  export interface WatchlistScope extends ng.IScope {
    watchlists: Array<Watchlist>;
    newWatchlist: Watchlist;
    watchlistForm: ng.IFormController;
    isEdit: boolean;
    events: WatchlistsCtrl;
    isLoading: boolean;
    secIds: string;
    isBusy: boolean;
    isError: boolean;
    hasData: boolean;
  }

  export class WatchlistsCtrl extends AnalysisBaseCtrl {
    scope: Patersons.WatchlistScope;
    analysisService: Patersons.AnalysisService;
    selectionService: Patersons.SelectionService;

    static $inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'analysisService', 'selectionService', 'navigationService'];

    constructor($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, analysisService, selectionService, navigationService) {
      super($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
      this.scope = $scope;
      this.scope.events = this;
      this.analysisService = analysisService;
      this.selectionService = selectionService;
      this.scope.isError = false;
      this.scope.hasData = false;

      if (this.state.params['add']) {
        this.selectionService.selectedWatchlistSecIds = this.state.params['add'];
        $location.url($location.path());
      }else if (this.selectionService.selectedWatchlistSecIds) {
        this.scope.secIds = this.selectionService.selectedWatchlistSecIds;
        this.selectionService.selectedWatchlistSecIds = null;
      }

      this.scope.isBusy = false;

      this.scope.isEdit = false;

      this.scope.watchlists = new Array<Watchlist>();
      this.getWatchlists();
    }

    onDeleteWatchlist = function(value) {
      if (confirm('Are you sure you want to delete watchlist?')) {
        this.scope.deleteWatchlist(value);
      }
    };

    listWatchlists(): string {
      return this.scope.watchlists.map(w => w.name.toLowerCase()).join("|");
    }

    deleteWatchlist(watchlistId: number) {
      if(confirm("Are you sure you wish to delete this watchlist?")){
        var promise: ng.IHttpPromise<any> = this.analysisService.deleteWatchlist(watchlistId);
        promise.then((result) => {
          this.getWatchlists();
          this.scope.isError = false;
          this.scope.hasData = true;
        },
          (reason) => { // errro handling
            //this.analysisService.errorHandler = reason.data;
            this.scope.isError = true;
            this.scope.hasData = false;
          }
        );
      }
    }

    getWatchlists() {
      this.scope.isLoading = true;
      var promise = this.analysisService.getWatchlists();
      promise.then((result) => {
        this.scope.isLoading = false;
        this.scope.watchlists = result;
        this.scope.isError = false;
        this.scope.hasData = true;
      },
        (reason) => { // error handling
          //this.analysisService.errorHandler = reason.data;
          this.scope.isError = true;
          this.scope.hasData = false;
        }
      );
    }

    prepareNewWatchlist() {
      this.scope.isEdit = true;
      this.scope.newWatchlist = new Watchlist();
    }

    addWatchlist() {
      this.scope.$broadcast('show-errors-check-validity');

      if (this.scope.watchlistForm.$invalid) {
        return;
      }

      this.scope.isBusy = true;
      this.scope.isLoading = true;
      this.analysisService.postWatchlist(this.scope.newWatchlist).then((result) => {
        this.scope.isLoading = false;
        this.scope.isEdit = false
        this.getWatchlists();
        this.scope.isError = false;
        this.scope.hasData = true;
      },
        (reason) => { // error handling
          //this.analysisService.errorHandler = reason.data;
          this.scope.isError = true;
          this.scope.hasData = false;
        }
      ).finally(() => {
        this.scope.isBusy = false;
      });
    }

    cancelAddWatchlist(): void {
      this.scope.isEdit = false;
      this.scope.watchlistForm.$setPristine();
      this.scope.watchlistForm.$setUntouched();
    }

    loadWatchlist(watchlistId: number) {
      var newSecIds = [];
      if (this.scope.secIds !== undefined || this.scope.secIds != null) {
        var newItems = this.scope.secIds.split(',');
        for (var i = 0; i < newItems.length; i++) {
          newSecIds.push(newItems[i]);
        }


        var promise = this.analysisService.getAWatchlist(watchlistId);
        promise.then((watchlist: Watchlist) => {

          for (var i = 0; i < newSecIds.length; i++) {
            watchlist.watchlistItems.push(newItems[i]);
          }

          var unique = watchlist.watchlistItems.filter(function(elem, index, self) {
            return index == self.indexOf(elem);
          })
          watchlist.watchlistItems = unique;
          this.analysisService.patchWatchlist(watchlist).then(() => {
            this.state.go("watchlistView", {
              "watchlistId": watchlistId
            });
          });

        });
    }else{
      this.state.go("watchlistView", {
        "watchlistId": watchlistId
      });
    }

    }
  }
}
